import { Link } from "react-router"

interface Breadcrumbs {
  name: string
  url: string
}

export default function BreadCrumbs({ items }: { items: Breadcrumbs[] }) {
  return (
    <div className="relative z-[1] w-full">
      <ul
        className={`
          my-0 mx-auto
          py-4 px-6 md:px-20
          flex items-center
          text-[14px]
          text-previous-gray
          w-full
          overflow-hidden
        `}
      >
        {items.map((item, index) => (
          <li
            className={`
              whitespace-nowrap
              [&:not(:last-child)::after]:inline-block
              [&:not(:last-child)::after]:content-[">"]
              [&:not(:last-child)::after]:my-0
              [&:not(:last-child)::after]:mx-2.5
              last:max-w-[400px]
              last:text-ellipsis
              last:overflow-hidden
            `}
            key={`${index}-${item.name}`}
          >
            {item.url !== "" ? (
              <Link to={item.url} className="text-black hover-opaque">
                {item.name}
              </Link>
            ) : (
              <span>{item.name}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
